/* eslint-disable react/jsx-props-no-spreading */
import { Paper, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    borderRadius: '8px',
    border: `1px solid ${theme.colors.main200}`,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(3)
  }
}))

export default function MainContentPaper(props: Record<string, any>): JSX.Element {
  const classes = useStyles()
  return <Paper className={classes.paper} elevation={0} {...props} />
}
